import { ReactElement } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PAGE_ICONS, PAGE_ROUTES } from '../../_const';
import PageWithBreadcrumbs from '../../components/layouts/NEPageWithBreadcrumbs';
import ViewLayout from '../../components/layouts/ViewLayout';
import EpicCareLinkUserContainer from './EpicCareLinkUserContainer';

/**
 * EpicCare Link User - new non-employee creation workflow
 * @returns {ReactElement} New EpicCare Link User Non-Employee Form with help panel, breadcrumb navigation
 */
const EpicCareLinkUserView = () => {
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'New EpicCare Link User'}
			CurrentPageIcon={PAGE_ICONS.IDENTITY}
		>
			<ViewLayout
				title={'New EpicCare Link User'}
				help={{
					title: 'Create New Non-Employee: EpicCare Link User',
					contents: (
						<Stack direction={'column'} spacing={2}>
							<Typography>
								This workflow is designed for EpicCare Link site
								administrators who wish to register new EpicCare
								Link Users and request EpicCare Link application
								access through IMS.
							</Typography>
							<Typography>
								This is a more streamlined workflow than
								requesting a new Non-Employee (
								<a
									href={PAGE_ROUTES.LEGACY_HOME}
									rel='noopener noreferrer'
									target='_parent'
								>
									Request &gt; Add Non-Employee Account
								</a>
								) and makes several assumptions about you, the
								requestor, and the new non-employee account you
								are creating. Please do not use this form unless
								you are an EpicCare site administrator and you
								are requesting EpicCare Link application access
								for a new non-employee user.
							</Typography>
							<Typography>
								If the EpicCare Link User has already been
								registered with IMS and you are looking to
								request EpicCare Link, please leave this page
								and navigate to the application request workflow
								(
								<a
									href='/index.html?redirect=/RequestFlow/RequesteeSearch'
									rel='noopener noreferrer'
									target='_parent'
								>
									Request &gt; Application Access &gt; App
									Request For Others
								</a>
								)
							</Typography>
							<Typography>
								For a more detailed usage guide, please refer to
								the{' '}
								<a
									href='https://infonet.upmc.com/infonet/ls/content/8932526666595017/add-non-employee-as-epiccare-link-user-pdf-1764799986'
									rel='noopener noreferrer'
									target='_blank'
								>
									Add a Non-Employee as an EpicCare Link User
									- Guide for Site Admins
								</a>{' '}
								tip-sheet on InfoNet.
							</Typography>
						</Stack>
					),
				}}
			>
				<EpicCareLinkUserContainer />
			</ViewLayout>
		</PageWithBreadcrumbs>
	);
};

export default EpicCareLinkUserView;
